import Vue from 'vue'
import { Customer, CostCenter, go } from '@/models'

import Accounts from './Accounts.vue'
// import Health from './Health.vue'
// import InstalledBase from './InstalledBase.vue'
import CostCenters from './CostCenters.vue'
import Historia from './Historia.vue'
// import Orgs from './Orgs.vue'
import Overview from './Overview.vue'

export default new Vue({
  data() {
    return {
      isLoading: false,
      currentTab: 'overview',
      id: null,
      row: null
    }
  },
  computed: {
    tabItems() {
      return [
        {
          value: 'overview',
          // group: 'Geral',
          label: 'Cadastro',
          component: Overview
        },

        {
          value: 'historia',
          // group: 'Geral',
          label: 'História',
          component: Historia
        },

        // {
        //   value: 'health',
        //   // group: 'Geral',
        //   label: 'Saúde',
        //   component: Health
        // },
        // {
        //   value: 'installedBase',
        //   // group: 'Geral',
        //   label: 'Veículos/Módulos',
        //   component: InstalledBase
        // },
        // {
        //   value: 'orgs',
        //   // group: 'Geral',
        //   label: 'Sistemas',
        //   component: Orgs
        // },
        {
          value: 'accounts',
          // group: 'Geral',
          label: 'Contatos',
          component: Accounts
        },
        {
          value: 'costCenters',
          // group: 'Geral',
          label: 'Centros de Custo',
          component: CostCenters
        }
      ]
    }
  },
  methods: {
    async load(id) {
      this.id = id
      this.row = null

      let row = await Customer.findById(this.id)
      let costCenters = await CostCenter.findAll({
        customerIds: this.id,
        limit: 10000
      })

      row.costCenters = costCenters

      if (row.links == null) row.links = []

      this.row = row
    },

    async reload() {
      return await this.load(this.id)
    },

    async patch(what) {
      await go.patch('/customers/' + this.id, what)
      await this.reload()
    }

    // async patch(body) {
    //   await Camera.patch(this.row.id, body)
    //   await this.load(this.row.id)
    // },

    // async deactivate() {
    //   await Camera.delete(this.row.id)
    //   await this.load(this.row.id)
    // }
  }
})
